export const menus = [
  {
    role: 'SUPER_ADMIN',
    items: [
      // {
      //   to: "/portals/dashboard",
      //   img: "/images/dashboardIcon.svg",
      //   activeImg: "/images/dashboardActive.svg",
      //   label: "Dashboard",
      //   icon: "mdi-minus-network",
      //   moduleName: "dashboard",
      // },
      {
        to: '/portals/userManagmnt/viewUser',
        img: '/images/User.svg',
        activeImg: '/images/InActiveUser.svg',
        label: 'Users',
        icon: 'mdi-minus-network',
        moduleName: 'userManagmnt',
      },
    ],
  },
  {
    role: 'SALES_ADMIN',
    items: [
      {
        to: '/portals/userManagmnt/viewUser',
        img: '/images/User.svg',
        activeImg: '/images/InActiveUser.svg',
        label: 'Users',
        icon: 'mdi-minus-network',
        moduleName: 'userManagmnt',
      },
      {
        label: 'Leads',
        icon: 'mdi-minus-network',
        moduleName: 'leads',
        img: '/images/LeadsIcon.svg',
        activeImg: '/images/active leads icon.svg',
        subItems: [
          { to: '/portals/leads/addUser', label: 'Add Leads' },
          { to: '/portals/leads/viewUser', label: 'View Leads' },
          { to: '/portals/leads/declinedUsers', label: 'Declined Leads' },
          // { to: '/portals/posts/createPost',img:'/images/posts.svg',activeImg:'/images/postsActive.svg', label: 'Posts', icon: 'mdi-minus-network',moduleName:'posts' },
        ],
      },
    ],
  },
  {
    role: 'SALES_MANAGER',
    items: [
      {
        to: '/portals/userManagmnt/viewUser',
        img: '/images/User.svg',
        activeImg: '/images/InActiveUser.svg',
        label: 'Users',
        icon: 'mdi-minus-network',
        moduleName: 'userManagmnt',
      },
      {
        label: 'Leads',
        icon: 'mdi-minus-network',
        moduleName: 'leads',
        img: '/images/LeadsIcon.svg',
        activeImg: '/images/active leads icon.svg',
        subItems: [
          { to: '/portals/leads/addUser', label: 'Add Leads' },
          { to: '/portals/leads/viewUser', label: 'View Leads' },
          { to: '/portals/leads/declinedUsers', label: 'Declined Leads' },
          // { to: '/portals/posts/createPost',img:'/images/posts.svg',activeImg:'/images/postsActive.svg', label: 'Posts', icon: 'mdi-minus-network',moduleName:'posts' },
        ],
      },
    ],
  },
  {
    role: 'SALES_TEAM_LEAD',
    items: [
      {
        to: '/portals/userManagmnt/viewUser',
        img: '/images/User.svg',
        activeImg: '/images/InActiveUser.svg',
        label: 'Users',
        icon: 'mdi-minus-network',
        moduleName: 'userManagmnt',
      },
      {
        label: 'Leads',
        icon: 'mdi-minus-network',
        moduleName: 'leads',
        img: '/images/LeadsIcon.svg',
        activeImg: '/images/active leads icon.svg',
        subItems: [
          { to: '/portals/leads/addUser', label: 'Add Leads' },
          { to: '/portals/leads/viewUser', label: 'View Leads' },
          { to: '/portals/leads/declinedUsers', label: 'Declined Leads' },
          // { to: '/portals/posts/createPost',img:'/images/posts.svg',activeImg:'/images/postsActive.svg', label: 'Posts', icon: 'mdi-minus-network',moduleName:'posts' },
        ],
      },
      // {
      //   label: "Vendors",
      //   icon: "mdi-minus-network",
      //   moduleName: "vendors",
      //   img: "/images/vendor.svg",
      //  activeImg: "/images/vendorActive.svg",
      //   subItems: [
      //     { to: "/portals/leads/addUser", label: "Add Leads" },
      //     { to: "/portals/leads/viewUser", label: "View Leads" },
      //     { to: "/portals/leads/declinedUsers", label: "Declined Leads" },
      //     // { to: '/portals/posts/createPost',img:'/images/posts.svg',activeImg:'/images/postsActive.svg', label: 'Posts', icon: 'mdi-minus-network',moduleName:'posts' },
      //   ],
      // },
    ],
  },
  {
    role: 'SALES_EXECUTIVE',
    items: [
      // { to: '/portals/userManagmnt/viewUser',img:'/images/User.svg',activeImg:'/images/InActiveUser.svg', label: 'Users', icon: 'mdi-minus-network',moduleName:'userManagmnt' },
      {
        label: 'Leads',
        icon: 'mdi-minus-network',
        moduleName: 'leads',
        img: '/images/LeadsIcon.svg',
        activeImg: '/images/active leads icon.svg',
        subItems: [
          { to: '/portals/leads/addUser', label: 'Add Leads' },
          { to: '/portals/leads/viewUser', label: 'View Leads' },
          { to: '/portals/leads/declinedUsers', label: 'Declined Leads' },
          // { to: '/portals/posts/createPost',img:'/images/posts.svg',activeImg:'/images/postsActive.svg', label: 'Posts', icon: 'mdi-minus-network',moduleName:'posts' },
        ],
      },
    ],
  },
  {
    role: 'SALES_ADMIN',
    items: [
      {
        label: 'Proposals',
        icon: 'mdi-minus-network',
        moduleName: 'Proposal',
        img: '/images/Props icon.svg',
        activeImg: '/images/active props icon.svg',
        subItems: [
          { to: '/portals/proposals/addProposal', label: 'Add Proposals' },
          { to: '/portals/proposals/viewProposal', label: 'View Proposals' },
          {
            to: '/portals/proposals/declineProposal',
            label: 'Declined Proposals',
          },
          // { to: '/portals/posts/createPost',img:'/images/posts.svg',activeImg:'/images/postsActive.svg', label: 'Posts', icon: 'mdi-minus-network',moduleName:'posts' },
        ],
      },
    ],
  },
  {
    role: 'SALES_MANAGER',
    items: [
      // { to: '/portals/userManagmnt/viewUser',img:'/images/User.svg',activeImg:'/images/InActiveUser.svg', label: 'Users', icon: 'mdi-minus-network',moduleName:'userManagmnt' },
      {
        label: 'Proposals',
        icon: 'mdi-minus-network',
        moduleName: 'Proposal',
        img: '/images/Props icon.svg',
        activeImg: '/images/active props icon.svg',
        subItems: [
          { to: '/portals/proposals/addProposal', label: 'Add Proposals' },
          { to: '/portals/proposals/viewProposal', label: 'View Proposals' },
          {
            to: '/portals/proposals/declineProposal',
            label: 'Declined Proposals',
          },
          // { to: '/portals/posts/createPost',img:'/images/posts.svg',activeImg:'/images/postsActive.svg', label: 'Posts', icon: 'mdi-minus-network',moduleName:'posts' },
        ],
      },
      // {
      //   label: "Vendors",
      //   icon: "mdi-minus-network",
      //   moduleName: "vendor",
      //   img: "/images/vendor.svg",
      //   activeImg: "/images/vendorActive.svg",
      //   subItems: [
      //     { to: "/portals/vendors/activeVendor", label: "Active Vendors" },
      //     { to: "/portals/vendors/inActiveVendor", label: "Inactive Vendors" },
      //   ],
      // },
    ],
  },
  {
    role: 'SALES_TEAM_LEAD',
    items: [
      // { to: '/portals/userManagmnt/viewUser',img:'/images/User.svg',activeImg:'/images/InActiveUser.svg', label: 'Users', icon: 'mdi-minus-network',moduleName:'userManagmnt' },
      {
        label: 'Proposals',
        icon: 'mdi-minus-network',
        moduleName: 'Proposal',
        img: '/images/Props icon.svg',
        activeImg: '/images/active props icon.svg',
        subItems: [
          { to: '/portals/proposals/addProposal', label: 'Add Proposals' },
          { to: '/portals/proposals/viewProposal', label: 'View Proposals' },
          {
            to: '/portals/proposals/declineProposal',
            label: 'Declined Proposals',
          },
          // { to: '/portals/posts/createPost',img:'/images/posts.svg',activeImg:'/images/postsActive.svg', label: 'Posts', icon: 'mdi-minus-network',moduleName:'posts' },
        ],
      },
      // {
      //   label: "Vendors",
      //   icon: "mdi-minus-network",
      //   moduleName: "vendor",
      //   img: "/images/vendor.svg",
      //   activeImg: "/images/vendorActive.svg",
      //   subItems: [
      //     { to: "/portals/vendors/activeVendor", label: "Active Vendors" },
      //     { to: "/portals/vendors/inActiveVendor", label: "Inactive Vendors" },
      //   ],
      // },
    ],
  },
  {
    role: 'SALES_EXECUTIVE',
    items: [
      // { to: '/portals/userManagmnt/viewUser',img:'/images/User.svg',activeImg:'/images/InActiveUser.svg', label: 'Users', icon: 'mdi-minus-network',moduleName:'userManagmnt' },
      {
        label: 'Proposals',
        icon: 'mdi-minus-network',
        moduleName: 'Proposal',
        img: '/images/Props icon.svg',
        activeImg: '/images/active props icon.svg',
        subItems: [
          { to: '/portals/proposals/addProposal', label: 'Add Proposals' },
          { to: '/portals/proposals/viewProposal', label: 'View Proposals' },
          {
            to: '/portals/proposals/declineProposal',
            label: 'Declined Proposals',
          },
          // { to: '/portals/posts/createPost',img:'/images/posts.svg',activeImg:'/images/postsActive.svg', label: 'Posts', icon: 'mdi-minus-network',moduleName:'posts' },
        ],
      },
      // {
      //   label: "Vendors",
      //   icon: "mdi-minus-network",
      //   moduleName: "vendor",
      //   img: "/images/vendor.svg",
      //   activeImg: "/images/vendorActive.svg",
      //   subItems: [
      //     { to: "/portals/vendors/activeVendor", label: "Active Vendors" },
      //     { to: "/portals/vendors/inActiveVendor", label: "Inactive Vendors" },
      //   ],
      // },
    ],
  },
  {
    role: 'SALES_ADMIN',
    items: [
      {
        label: 'Booked',
        icon: 'mdi-minus-network',
        moduleName: 'Booking',
        img: '/images/Booked icon.svg',
        activeImg: '/images/active booked icon.svg',
        subItems: [
          // { to: '/portals/bookings/addBooking', label: 'Add Booking'},
          { to: '/portals/bookings/viewBooking', label: 'View Booked' },
          {
            to: '/portals/bookings/confirmedBooking',
            label: 'View Confirmed',
          },
          // {
          //   to: "/portals/bookings/expiredService",
          //   label: "Expired Services",
          // },
          // { to: '/portals/posts/createPost',img:'/images/posts.svg',activeImg:'/images/postsActive.svg', label: 'Posts', icon: 'mdi-minus-network',moduleName:'posts' },
        ],
      },
      {
        label: 'Vendors',
        icon: 'mdi-minus-network',
        moduleName: 'vendor',
        img: '/images/vendor.svg',
        activeImg: '/images/vendorActive.svg',
        subItems: [
          { to: '/portals/vendors/activeVendor', label: 'Active Vendors' },
          {
            to: '/portals/vendors/inActiveVendor',
            label: 'Inactive Vendors',
          },
        ],
      },
      {
        label: 'Readers',
        icon: 'mdi-minus-network',
        moduleName: 'leads',
        img: '/images/inactive_patient_icon.svg',
        activeImg: '/images/PatientSideBarIcon.svg',
        subItems: [
          { to: '/portals/patients/ViewPatients', label: 'View Readers' },
          { to: '/portals/patients/viewSubscriber', label: 'Subscriber' },
        ],
      },
    ],
  },
  {
    role: 'SALES_ADMIN',
    items: [
      {
        label: 'Enquiries',
        icon: 'mdi-minus-network',
        moduleName: 'Enquiries',
        img: '/images/Booked icon.svg',
        activeImg: '/images/active booked icon.svg',
        subItems: [
          // { to: '/portals/bookings/addBooking', label: 'Add Booking'},
          { to: '/portals/enquiries/contactUs', label: 'Contact Us' },
          { to: '/portals/enquiries/posts', label: 'Posts' },
          {
            to: '/portals/enquiries/events',
            label: 'Events',
          },
          {
            to: '/portals/enquiries/vendors',
            label: 'Vendors',
          },
          // { to: '/portals/posts/createPost',img:'/images/posts.svg',activeImg:'/images/postsActive.svg', label: 'Posts', icon: 'mdi-minus-network',moduleName:'posts' },
        ],
      },
    ],
  },
  {
    role: 'SALES_MANAGER',
    items: [
      {
        label: 'Booked',
        icon: 'mdi-minus-network',
        moduleName: 'Booking',
        img: '/images/Booked icon.svg',
        activeImg: '/images/active booked icon.svg',
        subItems: [
          // { to: '/portals/bookings/addBooking', label: 'Add Booking'},
          { to: '/portals/bookings/viewBooking', label: 'View Booked' },
          { to: '/portals/bookings/confirmedBooking', label: 'Confirmed' },
          // {
          //   to: "/portals/bookings/expiredService",
          //   label: "Expired Services",
          // },
          // { to: '/portals/posts/createPost',img:'/images/posts.svg',activeImg:'/images/postsActive.svg', label: 'Posts', icon: 'mdi-minus-network',moduleName:'posts' },
        ],
      },
    ],
  },
  {
    role: 'SALES_TEAM_LEAD',
    items: [
      {
        label: 'Booked',
        icon: 'mdi-minus-network',
        moduleName: 'Booking',
        img: '/images/Booked icon.svg',
        activeImg: '/images/active booked icon.svg',
        subItems: [
          // { to: '/portals/bookings/addBooking', label: 'Add Booking'},
          { to: '/portals/bookings/viewBooking', label: 'View Booked' },
          { to: '/portals/bookings/confirmedBooking', label: 'Confirmed' },
          // {
          //   to: "/portals/bookings/expiredService",
          //   label: "Expired Services",
          // },
          // { to: '/portals/posts/createPost',img:'/images/posts.svg',activeImg:'/images/postsActive.svg', label: 'Posts', icon: 'mdi-minus-network',moduleName:'posts' },
        ],
      },
    ],
  },
  {
    role: 'SALES_EXECUTIVE',
    items: [
      {
        label: 'Booked',
        icon: 'mdi-minus-network',
        moduleName: 'Booking',
        img: '/images/Booked icon.svg',
        activeImg: '/images/active booked icon.svg',
        subItems: [
          // { to: '/portals/bookings/addBooking', label: 'Add Booking'},
          { to: '/portals/bookings/viewBooking', label: 'View Booked' },
          { to: '/portals/bookings/confirmedBooking', label: 'Confirmed' },
          // {
          //   to: "/portals/bookings/expiredService",
          //   label: "Expired Services",
          // },
          // { to: '/portals/posts/createPost',img:'/images/posts.svg',activeImg:'/images/postsActive.svg', label: 'Posts', icon: 'mdi-minus-network',moduleName:'posts' },
        ],
      },
    ],
  },
  {
    role: 'CONTENT_ADMIN',
    items: [
      // {
      //   to: "/portals/dashboard",
      //   img: "/images/dashboardIcon.svg",
      //   activeImg: "/images/dashboardActive.svg",
      //   label: "Dashboard",
      //   icon: "mdi-minus-network",
      //   moduleName: "dashboard",
      // },
      {
        to: '/portals/userManagmnt/viewUser',
        img: '/images/User.svg',
        activeImg: '/images/InActiveUser.svg',
        label: 'Users',
        icon: 'mdi-minus-network',
        moduleName: 'userManagmnt',
      },
      {
        to: '/portals/posts/viewPosts',
        img: '/images/posts.svg',
        activeImg: '/images/postsActive.svg',
        label: 'Posts',
        icon: 'mdi-minus-network',
        moduleName: 'posts',
        subItems: [
          {
            to: '/portals/posts/viewPosts',
            label: 'View Posts',
          },

          {
            to: '/portals/posts/viewEventsPosts',
            label: 'View Events',
          },
        ],
      },
      {
        label: 'Post Management',
        icon: 'mdi-minus-network',
        moduleName: 'Post Management',
        img: '/images/PostManagement_Inactive icon.svg',
        activeImg: '/images/postManagement_ActiveIcon.svg',
        subItems: [
          { to: '/portals/postManagement/news', label: 'News' },
          { to: '/portals/postManagement/articles', label: 'Articles' },
          { to: '/portals/postManagement/interviews', label: 'Interviews' },
          { to: '/portals/postManagement/reports', label: 'Reports' },
          {
            to: '/portals/postManagement/whitePapers',
            label: 'White Papers',
          },
          { to: '/portals/postManagement/webinars', label: 'Webinars' },
          { to: '/portals/postManagement/videos', label: 'Videos' },
          { to: '/portals/postManagement/events', label: 'Events' },
          {
            to: '/portals/postManagement/landingPage',
            label: 'Landing Page',
          },
        ],
      },
      {
        label: 'Seo Settings',
        icon: 'mdi-minus-network',
        moduleName: 'Seo Settings',
        img: '/images/PostManagement_Inactive icon.svg',
        activeImg: '/images/postManagement_ActiveIcon.svg',
        subItems: [
          {
            to: '/portals/seoSettings/pages',
            label: 'Pages',
            subItems: [
              {
                to: '/portals/seoSettings/pages/index-page',
                label: 'Index Page',
              },
              { to: '/portals/seoSettings/pages/news', label: 'News' },
              {
                to: '/portals/seoSettings/pages/articles',
                label: 'Articles',
              },
              {
                to: '/portals/seoSettings/pages/interviews',
                label: 'Interviews',
              },
              { to: '/portals/seoSettings/pages/reports', label: 'Reports' },
              { to: '/portals/seoSettings/pages/events', label: 'Events' },
              {
                to: '/portals/seoSettings/pages/white-papers',
                label: 'White Papers',
              },
              {
                to: '/portals/seoSettings/pages/webinars',
                label: 'Webinars',
              },
              { to: '/portals/seoSettings/pages/videos', label: 'Videos' },
              {
                to: '/portals/seoSettings/pages/hospital-profiles',
                label: 'Hospital Profiles',
              },
              {
                to: '/portals/seoSettings/pages/company-profiles',
                label: 'Company Profiles',
              },
              {
                to: '/portals/seoSettings/pages/contact-us',
                label: 'Contact Us',
              },
            ],
          },
          {
            to: '/portals/seoSettings/services',
            label: 'Topics',
            subItems: [
              { to: '/portals/seoSettings/services/ivf', label: 'IVF' },
              { to: '/portals/seoSettings/services/iui', label: 'IUI' },
              { to: '/portals/seoSettings/services/icsi', label: 'ICSI' },
              {
                to: '/portals/seoSettings/services/sperm-egg-freezing',
                label: 'Sperm/ Egg Freezing',
              },
              {
                to: '/portals/seoSettings/services/surrogacy',
                label: 'Surrogacy',
              },
              {
                to: '/portals/seoSettings/services/art',
                label: 'Art',
              },
            ],
          },
        ],
      },
      {
        label: 'Vendors',
        icon: 'mdi-minus-network',
        moduleName: 'vendor',
        img: '/images/vendor.svg',
        activeImg: '/images/vendorActive.svg',
        subItems: [
          { to: '/portals/vendors/activeVendor', label: 'Active Vendors' },
          {
            to: '/portals/vendors/inActiveVendor',
            label: 'Inactive Vendors',
          },
        ],
      },
    ],
  },
  {
    role: 'JUNIOR_EDITOR',
    items: [
      // {
      //   to: "/portals/dashboard",
      //   img: "/images/dashboardIcon.svg",
      //   activeImg: "/images/dashboardActive.svg",
      //   label: "Dashboard",
      //   icon: "mdi-minus-network",
      //   moduleName: "dashboard",
      // },
      {
        to: '/portals/posts/viewPosts',
        img: '/images/posts.svg',
        activeImg: '/images/postsActive.svg',
        label: 'Posts',
        icon: 'mdi-minus-network',
        moduleName: 'posts',
        subItems: [
          {
            to: '/portals/posts/createPost',
            label: 'Add Post',
          },
          {
            to: '/portals/posts/viewPosts',
            label: 'View Posts',
          },
          {
            to: '/portals/posts/addEvents',
            label: 'Add Events',
          },
          {
            to: '/portals/posts/viewEventsPosts',
            label: 'View Events',
          },
          // {
          //   to: "/portals/posts/expiredEventsPosts",
          //   label: "Expired Events",
          // },
          // {
          //   to: "/portals/posts/returnForEdits",
          //   label: "Return for Edits",
          // },
          {
            to: '/portals/posts/tags',
            label: 'Tags',
          },
          {
            to: '/portals/posts/archived',
            label: 'Archived Posts',
          },
        ],
      },
      {
        activeImg: '/images/leads.svg',
        label: 'Content-Listed Companies',
        icon: 'mdi-minus-network',
        moduleName: 'contentCompanies',
        img: '/images/leads.svg',
        subItems: [
          {
            to: 'contentCompanies/addCompany',
            label: 'Add Company',
          },
          {
            to: 'contentCompanies/viewCompanies',
            label: 'View Companies',
          },
        ],
      },
      // {
      //   activeImg:'/images/leads.svg',
      //   label: "Vendors",
      //   icon: "mdi-minus-network",
      //   moduleName: "vendors",
      //   img: "/images/leads.svg",
      //   subItems: [
      //     {
      //       to: "/portals/posts/vendors/activeVendors",
      //       label: "Active Vendors",
      //     }
      //   ],
      // }
    ],
  },
  {
    role: 'CHIEF_EDITOR',
    items: [
      // {
      //   to: "/portals/dashboard",
      //   img: "/images/dashboardIcon.svg",
      //   activeImg: "/images/dashboardActive.svg",
      //   label: "Dashboard",
      //   icon: "mdi-minus-network",
      //   moduleName: "dashboard",
      // },
      {
        to: '/portals/posts/viewPosts',
        img: '/images/posts.svg',
        activeImg: '/images/postsActive.svg',
        label: 'Posts',
        icon: 'mdi-minus-network',
        moduleName: 'posts',
        subItems: [
          {
            to: '/portals/posts/createPost',
            label: 'Add Post',
          },
          {
            to: '/portals/posts/viewPosts',
            label: 'View Posts',
          },
          {
            to: '/portals/posts/addEvents',
            label: 'Add Events',
          },
          {
            to: '/portals/posts/viewEventsPosts',
            label: 'View Events',
          },
          // {
          //   to: "/portals/posts/expiredEventsPosts",
          //   label: "Expired Events",
          // },
          // {
          //   to: "/portals/posts/returnForEdits",
          //   label: "Return for Edits",
          // },
          {
            to: '/portals/posts/tags',
            label: 'Tags',
          },
          {
            to: '/portals/posts/archived',
            label: 'Archived Posts',
          },
        ],
      },
      {
        to: '/portals/sectors',
        img: '/images/posts.svg',
        activeImg: '/images/postsActive.svg',
        label: 'Sectors',
        icon: 'mdi-minus-network',
        moduleName: 'sectors',
        subItems: [
          {
            to: '/portals/sectors/viewSector',
            label: ' View Sectors',
          },
        ],
      },
      {
        activeImg: '/images/leads.svg',
        label: 'Content-Listed Companies',
        icon: 'mdi-minus-network',
        moduleName: 'contentCompanies',
        img: '/images/leads.svg',
        subItems: [
          {
            to: 'contentCompanies/addCompany',
            label: 'Add Company',
          },
          {
            to: 'contentCompanies/viewCompanies',
            label: 'View Companies',
          },
        ],
      },
      {
        label: 'Vendors',
        icon: 'mdi-minus-network',
        moduleName: 'vendor',
        img: '/images/vendor.svg',
        activeImg: '/images/vendorActive.svg',
        subItems: [
          { to: '/portals/vendors/activeVendor', label: 'Active Vendors' },
          {
            to: '/portals/vendors/inActiveVendor',
            label: 'Inactive Vendors',
          },
        ],
      },
    ],
  },
  {
    role: 'UPLOADER',
    items: [
      // {
      //   to: "/portals/dashboard",
      //   img: "/images/dashboardIcon.svg",
      //   activeImg: "/images/dashboardActive.svg",
      //   label: "Dashboard",
      //   icon: "mdi-minus-network",
      //   moduleName: "dashboard",
      // },
      {
        to: '/portals/posts/viewPosts',
        img: '/images/posts.svg',
        activeImg: '/images/postsActive.svg',
        label: 'Posts',
        icon: 'mdi-minus-network',
        moduleName: 'posts',
        subItems: [
          {
            to: '/portals/posts/createPost',
            label: 'Add Post',
          },
          {
            to: '/portals/posts/viewPosts',
            label: 'View Posts',
          },
          {
            to: '/portals/posts/addEvents',
            label: 'Add Events',
          },
          {
            to: '/portals/posts/viewEventsPosts',
            label: 'View Events',
          },
          // {
          //   to: "/portals/posts/expiredEventsPosts",
          //   label: "Expired Events",
          // },
          {
            to: '/portals/posts/tags',
            label: 'Tags',
          },
          {
            to: '/portals/posts/archived',
            label: 'Archived Posts',
          },
        ],
      },
      // {
      //   activeImg:'/images/leads.svg',
      //   label: "Vendors",
      //   icon: "mdi-minus-network",
      //   moduleName: "vendors",
      //   img: "/images/leads.svg",
      //   subItems: [
      //     {
      //       to: "/portals/posts/vendors/activeVendors",
      //       label: "Active Vendors",
      //     }
      //   ],
      // }
    ],
  },
  {
    role: 'PUBLISHER',
    items: [
      {
        to: '/portals/posts/viewPosts',
        img: '/images/posts.svg',
        activeImg: '/images/postsActive.svg',
        label: 'Posts',
        icon: 'mdi-minus-network',
        moduleName: 'posts',
        subItems: [
          {
            to: '/portals/posts/viewPosts',
            label: 'View Posts',
          },
          {
            to: '/portals/posts/viewEventsPosts',
            label: 'View Events',
          },
          {
            to: '/portals/posts/archived',
            label: 'Archived Posts',
          },
          // {
          //   to: "/portals/posts/expiredEventsPosts",
          //   label: "Expired Events",
          // },
        ],
      },
      {
        label: 'Vendors',
        icon: 'mdi-minus-network',
        moduleName: 'vendor',
        img: '/images/vendor.svg',
        activeImg: '/images/vendorActive.svg',
        subItems: [
          { to: '/portals/vendors/activeVendor', label: 'Active Vendors' },
          {
            to: '/portals/vendors/inActiveVendor',
            label: 'Inactive Vendors',
          },
        ],
      },
    ],
  },
];
